import { render } from "./SiteDetails.vue?vue&type=template&id=035f4ae8&ts=true"
import script from "./SiteDetails.vue?vue&type=script&lang=ts"
export * from "./SiteDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__